exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3yZfp {\n  width: 150px;\n  min-height: 150px;\n  text-align: center;\n}\n._3yZfp ._3Phmf,\n._3yZfp .RY1Fx {\n  width: 90px;\n  height: 90px;\n}\n", ""]);

// Exports
exports.locals = {
	"button": "_3yZfp",
	"icon": "_3Phmf",
	"placeholder": "RY1Fx"
};